// Who sees "Open terminal" (D79): the API's rule, mirrored to hide links it would refuse.

/** One of the user's own personal environments, or any personal one for a Super Admin. */
export function mayOpenShell(
  me: { personal_org_id: string; role: { is_super_admin: boolean } } | undefined,
  orgId: string,
  personal: boolean,
): boolean {
  if (!me || !personal) return false;
  return me.personal_org_id === orgId || me.role.is_super_admin;
}
